import { useAppStore } from "../store/appStore";
import type { AvailableLanguage } from "../utils/i18n";
import { updateDocumentLanguage } from "../utils/languageUtils";
import type React from "react";
import ukFlag from "../assets/usa.svg";
import jpFlag from "../assets/jp.svg";

const flagButtonClass = (active: boolean): string =>
	`w-8 h-8 rounded-sm overflow-hidden flex items-center justify-center border-2 transition ${
		active
			? "border-blue-600 shadow-lg shadow-blue-600/20 dark:border-blue-400 dark:shadow-blue-500/30"
			: "border-gray-300 opacity-70 hover:opacity-100 dark:border-gray-700"
	}`;

const LanguageSwitcher: React.FC = () => {
	const uiLanguage = useAppStore((state) => state.uiLanguage);
	const setUILanguage = useAppStore((state) => state.setUILanguage);
	const handleLanguageChange = (language: AvailableLanguage) => {
		setUILanguage(language);
		updateDocumentLanguage(language);
	};
	return (
		<div className="flex items-center space-x-2 mr-4">
			<button
				type="button"
				onClick={() => handleLanguageChange("en-GB")}
				className={flagButtonClass(uiLanguage === "en-GB")}
				aria-label="Switch to English"
				title="English"
			>
				<img src={ukFlag} alt="UK Flag" className="w-full h-full object-cover" />
			</button>

			<button
				type="button"
				onClick={() => handleLanguageChange("ja-JP")}
				className={flagButtonClass(uiLanguage === "ja-JP")}
				aria-label="日本語に切り替え"
				title="日本語"
			>
				<img src={jpFlag} alt="Japan Flag" className="w-full h-full object-cover" />
			</button>
		</div>
	);
};

export default LanguageSwitcher;
